import { useState, useEffect } from 'react';
import { FinanceService } from '../../../../core/services/FinanceService';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _ProductSupplier } from '../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}
export const SelectProductSupplierConstants = ({ idSelector, onChange, label }: Props) => {

    const { instance, setLista, lista } = useDataBean(_ProductSupplier)
    const [id, setID] = useState(NaN);

    useEffect(() => {
        setID(idSelector);
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(e);
        onChange(e);
    }

    const getLista = () => {
        instance.getProductSupplierConstants(null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    return (
        <>
            <label>{label ?? "Estado de Referencias Cruzadas"}</label>
            <select className="form-select" value={id} onChange={(e) => {
                const value = e.target.value ? Number(e.target.value) : null
                setValue(value)
            }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <option key={item.DataBeanProperties.Value} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}